// assets
import {
    HomeOutlined,
    AppstoreAddOutlined,
    BuildOutlined,
    ThunderboltOutlined,
    CalendarOutlined,
} from '@ant-design/icons';
import { NavGroupType } from './types';

// icons
const icons = {
    HomeOutlined,
    AppstoreAddOutlined,
    BuildOutlined,
    ThunderboltOutlined,
    CalendarOutlined,
};

// ==============================|| MENU ITEMS - PROPERTY MANAGEMENT ||============================== //

const property: NavGroupType = {
    id: 'group-property-management',
    title: 'menu.property_management.title',
    type: 'group',
    children: {} as { [key: string]: any },
    disabled: {
        qlive_property_management_district_list: {
            id: 'list-districts',
            title: 'menu.property_management.district.list.title',
            type: 'item',
            url: '/district',
            icon: icons.BuildOutlined,
            breadcrumbs: false,
            index: 0,
        },
        qlive_property_management_property_list: {
            id: 'list-properties',
            title: 'menu.property_management.property.list.title',
            type: 'item',
            url: '/property',
            icon: icons.HomeOutlined,
            breadcrumbs: false,
            index: 1,
        },
        qlive_property_management_calendar_event_list: {
            id: 'list-calendar-events',
            title: 'menu.property_management.calendar_event.list.title',
            type: 'item',
            url: '/calendar/entries',
            icon: icons.CalendarOutlined,
            index: 2,
            breadcrumbs: false,
        },
        qlive_property_management_report_topic_list: {
            id: 'list-report-topics',
            title: 'menu.property_management.report_topic.list.title',
            type: 'item',
            url: '/report',
            icon: icons.ThunderboltOutlined,
            breadcrumbs: false,
            index: 3,
        },
        qlive_property_management_property_create: {
            id: 'create-new-property',
            title: 'menu.property_management.property.create.title',
            type: 'item',
            url: '/property/new',
            icon: icons.AppstoreAddOutlined,
            breadcrumbs: false,
            index: 4,
        },
    },
};

export default property;
